// extracted by mini-css-extract-plugin
export default {"chip":"CustomChipsIcon_chip__p86dV"};